export default {
    employeeFiledOvertime: [],
    overtimeTypes: [],
    approvers: [],
    photoUpload:[]
}